/**
 * Waseem Baby Store - Global Multi-Currency Engine
 * Handles 34+ global currencies with live real-time price conversion and search filtering
 */

(function() {
  'use strict';

  // 34 Global Countries & Currencies Definition
  const AVAILABLE_COUNTRIES = [
    { name: 'Netherlands', code: 'NL', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇳🇱' },
    { name: 'Belgium', code: 'BE', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇧🇪' },
    { name: 'Germany', code: 'DE', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇩🇪' },
    { name: 'France', code: 'FR', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇫🇷' },
    { name: 'Spain', code: 'ES', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇪🇸' },
    { name: 'Italy', code: 'IT', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇮🇹' },
    { name: 'Austria', code: 'AT', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇦🇹' },
    { name: 'Ireland', code: 'IE', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇮🇪' },
    { name: 'Portugal', code: 'PT', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇵🇹' },
    { name: 'United Kingdom', code: 'GB', currency: 'GBP', symbol: '£', rate: 0.855, flag: '🇬🇧' },
    { name: 'United States', code: 'US', currency: 'USD', symbol: '$', rate: 1.085, flag: '🇺🇸' },
    { name: 'Canada', code: 'CA', currency: 'CAD', symbol: 'CA$', rate: 1.485, flag: '🇨🇦' },
    { name: 'Australia', code: 'AU', currency: 'AUD', symbol: 'AU$', rate: 1.655, flag: '🇦🇺' },
    { name: 'United Arab Emirates', code: 'AE', currency: 'AED', symbol: 'AED ', rate: 3.98, flag: '🇦🇪' },
    { name: 'Saudi Arabia', code: 'SA', currency: 'SAR', symbol: 'SAR ', rate: 4.07, flag: '🇸🇦' },
    { name: 'Qatar', code: 'QA', currency: 'QAR', symbol: 'QAR ', rate: 3.95, flag: '🇶🇦' },
    { name: 'Kuwait', code: 'KW', currency: 'KWD', symbol: 'KD ', rate: 0.334, flag: '🇰🇼' },
    { name: 'Bahrain', code: 'BH', currency: 'BHD', symbol: 'BD ', rate: 0.409, flag: '🇧🇭' },
    { name: 'Oman', code: 'OM', currency: 'OMR', symbol: 'OMR ', rate: 0.418, flag: '🇴🇲' },
    { name: 'Pakistan', code: 'PK', currency: 'PKR', symbol: 'Rs ', rate: 302.5, flag: '🇵🇰' },
    { name: 'India', code: 'IN', currency: 'INR', symbol: '₹', rate: 90.8, flag: '🇮🇳' },
    { name: 'Switzerland', code: 'CH', currency: 'CHF', symbol: 'CHF ', rate: 0.965, flag: '🇨🇭' },
    { name: 'Japan', code: 'JP', currency: 'JPY', symbol: '¥', rate: 165.2, flag: '🇯🇵' },
    { name: 'Sweden', code: 'SE', currency: 'SEK', symbol: 'kr ', rate: 11.45, flag: '🇸🇪' },
    { name: 'Norway', code: 'NO', currency: 'NOK', symbol: 'kr ', rate: 11.62, flag: '🇳🇴' },
    { name: 'Denmark', code: 'DK', currency: 'DKK', symbol: 'kr ', rate: 7.46, flag: '🇩🇰' },
    { name: 'Poland', code: 'PL', currency: 'PLN', symbol: 'zł ', rate: 4.31, flag: '🇵🇱' },
    { name: 'Turkey', code: 'TR', currency: 'TRY', symbol: '₺', rate: 36.8, flag: '🇹🇷' },
    { name: 'Brazil', code: 'BR', currency: 'BRL', symbol: 'R$ ', rate: 5.88, flag: '🇧🇷' },
    { name: 'Singapore', code: 'SG', currency: 'SGD', symbol: 'SG$', rate: 1.46, flag: '🇸🇬' },
    { name: 'New Zealand', code: 'NZ', currency: 'NZD', symbol: 'NZ$', rate: 1.78, flag: '🇳🇿' },
    { name: 'South Africa', code: 'ZA', currency: 'ZAR', symbol: 'R ', rate: 19.85, flag: '🇿🇦' },
    { name: 'Mexico', code: 'MX', currency: 'MXN', symbol: 'MX$', rate: 21.6, flag: '🇲🇽' },
    { name: 'China', code: 'CN', currency: 'CNY', symbol: '¥', rate: 7.85, flag: '🇨🇳' }
  ];

  window.WASEEM_COUNTRIES = AVAILABLE_COUNTRIES;

  function getActiveCountry() {
    const saved = localStorage.getItem('waseem_selected_country');
    if (saved) {
      const found = AVAILABLE_COUNTRIES.find(c => c.code === saved);
      if (found) return found;
    }
    return AVAILABLE_COUNTRIES[0]; // Default Netherlands (EUR)
  }

  window.setWebsiteCountry = function(countryCode) {
    const country = AVAILABLE_COUNTRIES.find(c => c.code === countryCode);
    if (!country) return;

    localStorage.setItem('waseem_selected_country', country.code);
    localStorage.setItem('waseem_selected_currency', country.currency);

    updateCountryUI(country);
    convertAllPrices(country);

    try {
      window.dispatchEvent(new CustomEvent('waseem:currency:changed', { detail: { country } }));
    } catch(err) {}
  };

  function updateCountryUI(country) {
    if (!country) return;

    // 1. Update Drawer Trigger Label
    const drawerCountryLabel = document.getElementById('dore-country-current-label');
    if (drawerCountryLabel) {
      drawerCountryLabel.textContent = `${country.name.toUpperCase()} (${country.currency} ${country.symbol.trim()})`;
    }

    // 2. Update Topbar Trigger Label
    const topbarName = document.querySelector('.dore-topbar__country-name');
    const topbarCur = document.querySelector('.dore-topbar__country-cur');
    const topbarFlag = document.getElementById('dore-topbar-current-flag');
    if (topbarName) topbarName.textContent = country.name;
    if (topbarCur) topbarCur.textContent = `(${country.currency} ${country.symbol.trim()})`;
    if (topbarFlag) topbarFlag.textContent = country.flag;

    // 3. Update Drawer List Active States
    document.querySelectorAll('.dore-country-select-btn').forEach(btn => {
      const code = btn.getAttribute('data-code');
      const item = btn.closest('li') || btn.parentElement;
      if (code === country.code) {
        if (item) item.classList.add('is-active');
        if (!btn.querySelector('.dore-drawer__check')) {
          const check = document.createElement('span');
          check.className = 'dore-drawer__check';
          check.textContent = '✓';
          btn.appendChild(check);
        }
      } else {
        if (item) item.classList.remove('is-active');
        const check = btn.querySelector('.dore-drawer__check');
        if (check) check.remove();
      }
    });

    // 4. Update Topbar List Active States
    document.querySelectorAll('.dore-topbar__country-option').forEach(btn => {
      const code = btn.getAttribute('data-code');
      const item = btn.closest('li') || btn.parentElement;
      if (code === country.code) {
        if (item) item.classList.add('is-active');
        if (!btn.querySelector('.dore-topbar__check')) {
          const check = document.createElement('span');
          check.className = 'dore-topbar__check';
          check.setAttribute('aria-hidden', 'true');
          check.textContent = '✓';
          btn.appendChild(check);
        }
      } else {
        if (item) item.classList.remove('is-active');
        const check = btn.querySelector('.dore-topbar__check');
        if (check) check.remove();
      }
    });
  }

  function bindCountryOptions() {
    // 1. Drawer Option Clicks
    document.querySelectorAll('.dore-country-select-btn').forEach(btn => {
      btn.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        const code = this.getAttribute('data-code');
        if (code) {
          window.setWebsiteCountry(code);
        }
        const panel = document.getElementById('dore-country-panel');
        const toggle = document.getElementById('dore-country-trigger');
        if (panel) {
          panel.classList.remove('is-open');
          panel.setAttribute('hidden', '');
        }
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      };
    });

    // 2. Topbar Option Clicks
    document.querySelectorAll('.dore-topbar__country-option').forEach(btn => {
      btn.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        const code = this.getAttribute('data-code');
        if (code) {
          window.setWebsiteCountry(code);
        }
        const dropdown = document.getElementById('dore-topbar-country-dropdown');
        const toggle = document.getElementById('dore-topbar-country-toggle');
        if (dropdown) dropdown.setAttribute('hidden', '');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        const section = document.querySelector('.dore-topbar');
        if (section) section.classList.remove('is-dropdown-open');
      };
    });

    // 3. Search Input in Drawer
    const drawerSearch = document.getElementById('dore-country-search-input');
    if (drawerSearch) {
      drawerSearch.oninput = function(e) {
        const query = (e.target.value || '').trim().toLowerCase();
        document.querySelectorAll('#dore-country-results .dore-country-option').forEach(opt => {
          const name = opt.getAttribute('data-country-name') || '';
          const code = opt.getAttribute('data-country-code') || '';
          const cur = opt.getAttribute('data-currency-code') || '';
          const text = opt.textContent.toLowerCase();
          if (!query || name.includes(query) || code.includes(query) || cur.includes(query) || text.includes(query)) {
            opt.style.display = '';
          } else {
            opt.style.display = 'none';
          }
        });
      };
    }

    // 4. Search Input in Topbar
    const topbarSearch = document.getElementById('dore-topbar-search-input');
    if (topbarSearch) {
      topbarSearch.oninput = function(e) {
        const query = (e.target.value || '').trim().toLowerCase();
        document.querySelectorAll('#dore-topbar-country-list .dore-topbar__country-item').forEach(opt => {
          const name = opt.getAttribute('data-country-name') || '';
          const code = opt.getAttribute('data-country-code') || '';
          const cur = opt.getAttribute('data-currency-code') || '';
          const text = opt.textContent.toLowerCase();
          if (!query || name.includes(query) || code.includes(query) || cur.includes(query) || text.includes(query)) {
            opt.style.display = '';
          } else {
            opt.style.display = 'none';
          }
        });
      };
    }
  }

  // =========================================================================
  // PRICE CONVERSION HELPERS
  // =========================================================================
  function parsePrice(text) {
    if (!text) return null;
    const cleanText = text.replace(/EUR|USD|GBP|SAR|AED|QAR|PKR|INR|CAD|AUD/gi, '').trim();
    const match = cleanText.match(/[\d.,]+/);
    if (!match) return null;
    let str = match[0];
    if (str.indexOf('.') !== -1 && str.indexOf(',') !== -1) {
      if (str.indexOf('.') < str.indexOf(',')) {
        str = str.replace(/\./g, '').replace(',', '.');
      } else {
        str = str.replace(/,/g, '');
      }
    } else if (str.indexOf(',') !== -1) {
      str = str.replace(',', '.');
    }
    const val = parseFloat(str);
    return isNaN(val) ? null : val;
  }

  function formatMoney(amount, currency, symbol) {
    const cleanSymbol = (symbol || '').trim();
    if (currency === 'EUR') {
      return `€${amount.toFixed(2).replace('.', ',')}`;
    }
    if (['USD', 'CAD', 'AUD', 'NZD', 'SGD', 'HKD'].includes(currency)) {
      return `${cleanSymbol}${amount.toFixed(2)}`;
    }
    if (currency === 'GBP') {
      return `£${amount.toFixed(2)}`;
    }
    if (['PKR', 'INR', 'JPY', 'KRW'].includes(currency)) {
      return `${cleanSymbol} ${Math.round(amount).toLocaleString('en-US')}`;
    }
    if (['TRY', 'NOK', 'SEK', 'DKK', 'PLN', 'ZAR', 'MXN', 'BRL', 'CNY', 'CHF'].includes(currency)) {
      return `${cleanSymbol} ${amount.toFixed(2).replace('.', ',')}`;
    }
    if (['SAR', 'AED', 'QAR', 'KWD', 'BHD', 'OMR'].includes(currency)) {
      return `${cleanSymbol} ${amount.toFixed(2)}`;
    }
    return `${cleanSymbol} ${amount.toFixed(2)}`;
  }

  function convertAllPrices(country) {
    if (!country) return;

    const isEur = (country.currency === 'EUR' && country.rate === 1.0);

    const priceSelectors = [
      '.price-item',
      '.price-item--regular',
      '.price-item--sale',
      '.price-item--last',
      '.ai-featured-collection__price',
      '.ai-featured-collection__price-compare',
      '[class*="ai-featured-collection__price-"]',
      '[class*="ai-featured-collection__price_"]',
      '.dore-tabs__price-current',
      '.dore-tabs__price-compare',
      '[class*="dore-tabs__price-"]',
      '.dore-vr__cat-price',
      '.cart-drawer__total-price',
      '.cart-drawer__subtotal-value',
      '.cart-drawer__item-price',
      '.cart-drawer__item-original-price',
      '.cart-item__price',
      '.cart-item__original-price',
      '.cart-item__discounted-price',
      '.cart-shipping-bar__remaining',
      '.product__price',
      '.product-price',
      '.dore-product-price',
      '.dore-product-price--sale',
      '.dore-product-price--compare',
      '.dore-sticky-cart__price',
      '.quick-add__price',
      '.money',
      '[data-product-price]',
      '[data-price]'
    ];

    document.querySelectorAll(priceSelectors.join(',')).forEach(el => {
      // Exclude wrappers that contain child price elements
      if (
        el.matches('[class*="wrapper"], [class*="row"], [class*="container"]') ||
        el.querySelector('.price-item, .money, .ai-featured-collection__price, .dore-tabs__price-current, [class*="price-compare"], [class*="price-current"]')
      ) {
        return;
      }

      let original = el.getAttribute('data-original-price');
      if (!original) {
        original = el.textContent.trim();
        if (!original || !/[\d]/.test(original)) return;
        el.setAttribute('data-original-price', original);
      }

      if (isEur) {
        el.textContent = original;
        return;
      }

      const baseEur = parsePrice(original);
      if (baseEur !== null && baseEur > 0) {
        const converted = baseEur * country.rate;
        el.textContent = formatMoney(converted, country.currency, country.symbol);
      }
    });
  }

  // =========================================================================
  // INITIALIZATION
  // =========================================================================
  function init() {
    const activeCountry = getActiveCountry();

    bindCountryOptions();
    updateCountryUI(activeCountry);

    if (activeCountry.currency !== 'EUR') {
      setTimeout(() => convertAllPrices(activeCountry), 100);
      setTimeout(() => convertAllPrices(activeCountry), 500);
      setTimeout(() => convertAllPrices(activeCountry), 1200);
      setTimeout(() => convertAllPrices(activeCountry), 2500);
    }

    if (window.MutationObserver) {
      let debounceTimer = null;
      const observer = new MutationObserver(function() {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          const c = getActiveCountry();
          if (c.currency !== 'EUR') {
            convertAllPrices(c);
          }
        }, 120);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function() {
    bindCountryOptions();
    const active = getActiveCountry();
    updateCountryUI(active);
    if (active.currency !== 'EUR') {
      convertAllPrices(active);
    }
  });

  window.convertAllPrices = convertAllPrices;

})();
